import React from "react";
import { Typography, Card, Col, Row } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import "./NotesMaterial.less";
import {
  ROUTE_NOTES_WRITTEN_NOTES,
  ROUTE_NOTES_RECORDINGS,
  ROUTE_NOTES_ASSIGNMENTS,
} from "../../../constant/routes";

const { Title } = Typography;

const NotesMaterial = () => {
  const navigate = useNavigate();
  const { coaching_id } = useParams();

  const handleCardClick = (type) => {
    if (type === "writtennotes") {
      navigate(ROUTE_NOTES_WRITTEN_NOTES.replace(":id", coaching_id));
    }
    if (type === "recordings") {
      navigate(ROUTE_NOTES_RECORDINGS.replace(":id", coaching_id));
    }
    if (type === "assignments") {
      navigate(ROUTE_NOTES_ASSIGNMENTS.replace(":id", coaching_id));
    }
  };

  return (
    <div className='notes-material-container'>
      <div className='classes-notes'>
        <Title className='title'>Study Material</Title>
        <Col>
          <Card
            className='card'
            onClick={() => handleCardClick("writtennotes")}
          >
            <Row>
              <Title level={5}>Written Notes</Title>
            </Row>
          </Card>
          <Card className='card' onClick={() => handleCardClick("recordings")}>
            <Row>
              <Title level={5}>Recordings</Title>
            </Row>
          </Card>
          <Card className='card' onClick={() => handleCardClick("assignments")}>
            <Row>
              <Title level={5}>Assignments</Title>
            </Row>
          </Card>
        </Col>
      </div>
    </div>
  );
};

export default NotesMaterial;
